import { render, staticRenderFns } from "./bussiness.vue?vue&type=template&id=c2b02dae&scoped=true&"
import script from "./bussiness.vue?vue&type=script&lang=js&"
export * from "./bussiness.vue?vue&type=script&lang=js&"
import style0 from "./bussiness.vue?vue&type=style&index=0&id=c2b02dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b02dae",
  null
  
)

export default component.exports